import {
  Table,
  TableBody,
  TableCell,
  TableCellHead,
  TableHead,
  TableRow,
} from '~/ui/Table';
import { useTranslation } from 'react-i18next';
import { IconButton } from '~/ui';
import Edit from '~/assets/svg/newSvg/edit.svg?react';
import Basket from '~/assets/svg/newSvg/basket.svg?react';
import styles from './TournamentTable.module.scss';
import { useNavigate } from 'react-router-dom';
import ModalConfirm from '~/components/Shared/ModalConfirm';
import StockStatusBadge from '~/components/PromotionsBoard/StockBoard/StockTable/StockStatusBadge/StockStatusBadge';
import dayjs from 'dayjs';

interface ITournamentTableProps {
  sort: {
    field: string;
    direction: string;
  };
  setSort: ({ field, direction }: { field: string; direction: string }) => void;
  tournaments: {
    id: number;
    name: string;
    start_date: string;
    end_date: string;
    status: {
      id: number;
      name: string;
      type: string;
    };
  }[];
  deleteTournament: (id: number) => void;
  paginate: string;
}

const TournamentTable = ({
  sort,
  setSort,
  tournaments,
  deleteTournament,
  paginate,
}: ITournamentTableProps) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className={styles.tableContainer}>
      <Table>
        <TableHead setSort={setSort} sort={sort}>
          <TableCellHead field="name">{t('name')}</TableCellHead>
          <TableCellHead field="start_date">{t('start_date')}</TableCellHead>
          <TableCellHead field="end_date">{t('end_date')}</TableCellHead>
          <TableCellHead field="status">{t('status')}</TableCellHead>
          <TableCellHead field="actions" sortable={false}>
            {t('actions')}
          </TableCellHead>
        </TableHead>
        <TableBody>
          {tournaments.map(item => (
            <TableRow key={item.id}>
              <TableCell>{item.name}</TableCell>
              <TableCell>
                {dayjs(item.start_date).format('DD.MM.YYYY')}
              </TableCell>
              <TableCell>{dayjs(item.end_date).format('DD.MM.YYYY')}</TableCell>
              <TableCell className={styles.statusCell}>
                <StockStatusBadge status={item.status} />{' '}
              </TableCell>
              <TableCell>
                <div className={styles.actionsWrapper}>
                  <IconButton
                    // @ts-ignore
                    onClick={e => {
                      e.stopPropagation();
                      navigate(
                        `${item.id}${paginate ? `?paginate=${paginate}` : ''}`
                      );
                    }}
                  >
                    <Edit />
                  </IconButton>
                  <ModalConfirm
                    title={t('sure_delete_tournament')}
                    description={t('delete_tournament_description')}
                    onConfirm={async () => {
                      deleteTournament(item.id);
                    }}
                  >
                    {open => (
                      <IconButton
                        // @ts-ignore
                        onClick={event => {
                          event.stopPropagation();
                          open();
                        }}
                      >
                        <Basket />
                      </IconButton>
                    )}
                  </ModalConfirm>
                </div>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
};

export default TournamentTable;
